import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { ConfigProvider, App as AntdApp, theme as antdTheme } from "antd";
import { store } from "./store";
import App from "./App.jsx";
import { useTheme } from "./hooks/useTheme";
import "./index.css";
import "./utils/animations/animations.css";

const ThemeWrapper = ({ children }) => {
  const { isDark } = useTheme();

  return (
    <ConfigProvider
      theme={{
        algorithm: [
          isDark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
          antdTheme.compactAlgorithm
        ]
      }}
    >
      <AntdApp>
        {children}
      </AntdApp>
    </ConfigProvider>
  );
};

ReactDOM.createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <ThemeWrapper>
      <App />
    </ThemeWrapper>
  </Provider>
);
